export default {
  project: {
    listTitle: "Project list",
    newProject: "New Project:",
    name: "Project name",
    namePlaceholder: "Enter the project name",
    description: "Description",
    descriptionPlaceholder: "Enter the project description",
    myProjects: "My Projects",
    searchPlaceholder: "Search by name, description",
    addUser: "Add a member",
    updateProject: "Update project",
    viewProject: "See project",
    showMembers: "Show members",
    leaveProject: "Leave project",
    membersOfProject: "Project members",
    deleteUser: "Delete user",
    setAdmin: "Set as administrator",
    table: {
      name: "Project name",
      description: "Description",
      actions: "Actions",
      yourProfile: "Your profile",
      user: "User",
      profile: "Profile",
      email: "Email"
    },
    addMember: {
      addPopupTitle: "Add a member",
      email: "Email",
      emailPlaceholder: "Member's email address",
      role: "Role",
    },
    deleteMember: {
      confirmMessage: "Are you sure you want to delete this member from the project?"
    },
    deleteProject: {
      confirmMessage: "Are you sure you want to delete this project? This action is irreversible."
    },
    adminMember:{
      title:"Set as project administrator",
      confirmMessage: "Are you sure you want to set this member as project administrator?"
    },
    editProject: {
      viewPopupTitle: "See project",
      editPopupTitle: "Edit a project",
      name: "Name",
      description: "Description",
      meterPriceRural2Wires: "Rural meter price (2 wires)",
      meterPriceRural4Wires: "Rural meter price (4 wires)",
      meterPriceUrban2Wires: "Urban meter price (2 wires)",
      meterPriceUrban4Wires: "Urban meter price (4 wires)",
      eligibilityRadius: "Eligibility distance in metres"
    },
    change:{
      title:"Project change",
      message:"Do you really want to change projects?",
      message_2:"(The page will reload.)"
    }
  }
}
